// extracted by mini-css-extract-plugin
module.exports = {"mssUpdate":"resume-budget_mssUpdate__3HUB4"};